import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommitteeSearchDto } from '../shared/dto/committee-search.dto';

@Component({
  selector: 'wl-committee-search-params',
  templateUrl: './committee-search-params.component.html',
  styleUrls: ['./committee-search-params.component.less'],
    standalone: false
})
export class CommitteeSearchParamsComponent implements OnInit {
  @Input()
  get searchParams() {
    return this._searchParams;
  }
  set searchParams(value: CommitteeSearchDto) {
    this._searchParams = value;
    this.searchParamsChange.emit(this._searchParams);
  }
  @Output() searchParamsChange: EventEmitter<CommitteeSearchDto> = new EventEmitter();

  private _searchParams: CommitteeSearchDto;
  constructor() {}

  ngOnInit(): void {}
}
